import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Chart } from 'chart.js';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';
import { LineCharData } from 'src/app/modules/dashboard/utils/line_chart_data';

@Component({
  selector: 'user-report-resume',
  templateUrl: './user-report-resume.component.html',
  styleUrls: ['./user-report-resume.component.scss'],
})
export class UserReportResumeComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private resumeService: ResumeService,
    private unitsService: UnitsService
  ) {}

  ngOnInit() {
    this.resumeService.filterResumeReport.subscribe({
      next: (filters: any) => {
        for (let key in filters) {
          if (
            filters[key] == '' ||
            filters[key] == 'null' ||
            filters[key] == null
          ) {
            delete filters[`${key}`];
          }
        }

        this.getDataUserCases(filters);
      },
    });
    this.getDataUserCases();
  }
  data;
  dataSource;
  displayedColumns: string[] = [];
  unitSelected;
  units = [];

  setData(data: []) {
    this.data = data;
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
  }
  res;
  getDataUserCases(filters = {}) {
    this.resumeService.userCaseReportResumen(filters).subscribe((res: any) => {
      this.res = res;

      this.displayedColumns = res.labelsUserTable;
      this.setData(res.table);
      this.caseTypeStatus(res.casesByUserStatus);
      this.casesByUser(res.casesByUser);
    });
  }
  bar: Chart;
  casesByUser(data) {
    if (this.bar) {
      this.bar.destroy();
    }
    var canvas = document.getElementById(
      'UserReportResume'
    ) as HTMLCanvasElement;
    var parent = document.getElementById('contentUserReportResume');

    // canvas.width = parent.offsetWidth;
    this.bar = new Chart('UserReportResume', {
      type: 'bar',
      data: {
        labels: data.labels,

        datasets: [
          {
            data: data.countCases,
            backgroundColor: [
              '#005dd0',
              '#2e8cef',
              '#30c5ff',
              '#f6a506',
              '#f58500',
              '#ff5733',
              '#ff0055',
              '#ff33a1',
              '#7c5dff',
              '#3cff7c',
            ],
          },
        ],
      },
      options: {
        // indexAxis: 'y',
        elements: {
          // bar: {
          //   borderWidth: 2,
          // }
        },
        responsive: true,

        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var value =
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return value.toString();
            },
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
    });
  }
  barStatus: Chart;
  caseTypeStatus(data: any) {
    if (this.barStatus) {
      this.barStatus.destroy();
    }
    var canvas = document.getElementById(
      'UserReportResumeStatus'
    ) as HTMLCanvasElement;
    var parent = document.getElementById('contentUserReportResumeStatus');

    // canvas.width = parent.offsetWidth;
    this.barStatus = new Chart('UserReportResumeStatus', {
      type: 'bar',
      data: {
        labels: data.labels,

        datasets: data.data,
      },
      options: {
        // indexAxis: 'y',
        elements: {
          // bar: {
          //   borderWidth: 2,
          // }
        },
        responsive: true,

        legend: {
          display: true,
          position: 'bottom',
        },
        // tooltips: {
        //   callbacks: {
        //     label: function (tooltipItem, data) {
        //       var value =
        //         data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        //       return value.toString();
        //     },
        //   },
        // },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
    });
  }
}
